export const ALLOWABLE_HOSTS = [
  "www.epicurious.com",
  "epicurious.com",
  "bonappetit.com",
  "www.bonappetit.com",
  "cooking.nytimes.com",
];
